(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskAddEdit',
	};

	var form_id = 'taskaddedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var task_id = $('#' + form_id + 'id').val();

		_checkForType();

		// changing the task classification
		$('#' + form_id + 'classification').change(function onClassificationChange(e)
		{
			Adzuki.TaskManager.classificationFieldChange(form_id);

			_buildSummary();
		});

		// changing the due date based on for a classification
		$('#' + form_id + 'due_based_on').change(function onDueDateBasedChange(e)
		{
			Adzuki.TaskManager.dueBasedOnFieldChange(form_id);

			_buildSummary();
		});

		// change on the "Add Reminder?" radio
		$('.add-reminder').change(function onAddReminderChange(e)
		{
			var add_reminder = parseInt($(this).val());

			if (add_reminder === 1) {
				$('.reminder-field').removeClass('hidden');
			} else {
				$('#' + form_id + 'reminder_days').val('').trigger('change');
				$('.reminder-field').addClass('hidden');
			}

			_buildSummary();
		});

		// as changes are made on the form, re-create the summary
		$('.task-field').change(function buildSummary(e) {
			var field_id = $(this).attr('id');

			_buildSummary();

			// we are changing the task due days, check for warnings
			if (field_id === form_id + 'due_based_days') {
				Adzuki.TaskManager.showBasedOnWarning(form_id);
			}
		});


		// changing the due date, also re-creates the summary
		$('#' + form_id + 'due_date').on('dp.change', function onDueDateChange(e)
		{
			Adzuki.TaskManager.showReminderWarning(form_id);

			_buildSummary();
		});

		_initRecurrenceFields();

		Adzuki.TaskManager.initTaskForm(form_id);

		// when changing the reservation_id, check if there any other
		// reservations or groups linked to it. Also check if the reservation selected
		// is cancelled, and update the "Based On" options accordingly
		$('#' + form_id + 'reservation_id').change(function onReservationIdChange(e)
		{
			var reservation_id = $(this).val();

			Adzuki.TaskManager.populateDueDateBasedOn(form_id, 'reservation');

			if (reservation_id === '') {
				_hideAndUncheckLinkedCheckboxes();
				return;
			}

			Adzuki.TaskManager.getLinkedReservationsAndGroups(reservation_id, form_id, 'task_add_edit');
		});


		$('#' + form_id + 'type').on('change', function showTemplates() {
			let val = $(this).val();

			if (val === 'email') {
				$('.template-groups').removeClass('hidden');
			} else {
				$('.template-groups').addClass('hidden');
			}
		});

		// trigger check for linked reservations/groups
		if (!task_id && $('#' + form_id + 'reservation_id').val() !== '') {
			$('#' + form_id + 'reservation_id').trigger('change');
		}

		// check for warnings when setting up a reminder
		$('#' + form_id + 'reminder_days').change(function onReminderDaysChange(e)
		{
			Adzuki.TaskManager.showReminderWarning(form_id);
		});

		// if we're editing a task, we need to pre-populate the summary
		if ($('#' + form_id + 'id').val() !== '') {
			_buildSummary();
		}
	};

	form.success = function success(response)
	{
		var task_id            = $('#' + form_id + 'id').val();
		var $series_field      = $('#' + form_id + 'edit_recurrence_series');
		var $series_conf_field = $('#' + form_id + 'recurrence_series_confirmed');
		var $modal_form        = $('#' + form_id + 'modal_form');
		var $modal             = $('.modal');

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		if (response['status'] === 'confirmation_prompt') {
			$.confirm({
				title             : 'Recurring Tasks',
				animation         : 'opacity',
				theme             : 'bootstrap',
				icon              : Adzuki.FaIcon.getIconStyle('info_circle'),
				animateFromElement: false,
				backgroundDismiss : false,
				closeIcon         : true,
				content           : response.data,
				buttons           : {
					all_tasks: {
						text  : 'Update all tasks',
						action: function allTasks() {
							$series_field.val(1);
							$series_conf_field.val(1);
							$(form.element).submit();
						},
					},
					this_task: {
						text  : 'Update this task',
						action: function thisTask() {
							$series_conf_field.val(1);
							$(form.element).submit();
						},
					},
				},
				onOpenBefore: function _applyAdzukiStyle() {
					this.$body.addClass('adzuki-status confirm');
				}
			});

			return false;
		}

		// redirect if the form is not on a modal
		if ($modal_form.length === 0) {
			window.location.href = response['data'];
			return true;
		}

		task_id = response['data']['task_id'];

		// updated details on the modal, show success message and render the form on it
		Adzuki.StatusMessage('success', 'The task has been saved.', 'Success', {
			onClose: function onAlertClosed() {
				var url         = '/Tasks/viewTaskDetails/' + task_id,
				    history_url = '/Tasks/viewTaskHistory/' + task_id;

				Adzuki.Ajax.get(url)
					.then(function viewTaskDetails(response) {
						$modal.find('#task-details').html(response);
						$('#task-details-nav').data('changed', 1);

						Adzuki.Form.initAjaxForm('TaskAddEdit');
					});

				Adzuki.Ajax.get(history_url)
					.then(function viewTaskHistory(response) {
						$modal.find('#task-history').html(response);
					});
			}
		});
	};

	function _buildSummary()
	{
		var $form = $(form.element);

		Adzuki.Ajax.post('/Tasks/summary', $form.serialize()).then(
			function success(response) {
				$('.task-summary').html(response);
			}
		);
	}

	function _hideAndUncheckLinkedCheckboxes()
	{
		$('#task_add_edit .linked-reservations').addClass('hidden');
		$('#task_add_edit .group-reservations').addClass('hidden');

		$('#' + form_id + 'duplicate_linked').prop('checked', false);
		$('#' + form_id + 'duplicate_groups').prop('checked', false);
	}

	function _initRecurrenceFields()
	{
		var $daily_container   = $('.daily-pattern');
		var $weekly_container  = $('.weekly-pattern');
		var $monthly_container = $('.monthly-pattern');
		var $yearly_container  = $('.yearly-pattern');
		var $range_start_field = $('.date-range-start');
		var $range_end_field   = $('.date-range-end');
		var $count_range_field = $('.after-count-range');
		var task_id            = $('#' + form_id + 'id').val();

		// change on the "Add Recurrence?" radio
		$('.add-recurrence').change(function onAddReminderChange(e)
		{
			var add_recurrence = parseInt($(this).val());
			var classification = $('#' + form_id + 'classification').val();

			if (add_recurrence === 1) {
				$('.recurrence-container').removeClass('hidden');

				if (task_id) {
					$('.default-due-date').removeClass('hidden');
				} else {
					$('.default-due-date').addClass('hidden');
				}

				// a classification is set, due date based on should be hidden
				if (classification !== '') {
					$('.due-based-on-field').addClass('hidden');
					$('#' + form_id + 'due_based_on').val('').trigger('change');
				}
			} else {
				$('.recurrence-container').addClass('hidden');

				if (classification === '') {
					$('.default-due-date').removeClass('hidden');
				} else {
					$('.default-due-date').addClass('hidden');
					$('.due-based-on-field').removeClass('hidden');
				}

				$('#' + form_id + 'pattern').val('').trigger('change');
				$('#' + form_id + 'range_type').val('').trigger('change');
			}

			_buildSummary();
		});

		// changing the recurrence pattern
		$('#' + form_id + 'pattern').on('change', function onPatternChange(e)
		{
			var pattern = $(this).val();

			$daily_container.addClass('hidden');
			$weekly_container.addClass('hidden');
			$monthly_container.addClass('hidden');
			$yearly_container.addClass('hidden');

			switch (pattern) {
				case 'daily':
					$daily_container.removeClass('hidden');
					$('.daily-radios:checked').trigger('change');
				break;
				case 'weekly':
					$weekly_container.removeClass('hidden');
				break;
				case 'monthly':
					$monthly_container.removeClass('hidden');
					$('.monthly-radios:checked').trigger('change');
				break;
				case 'yearly':
					$yearly_container.removeClass('hidden');
					$('.yearly-radios:checked').trigger('change');
				break;
				default:
					// do nothing
			}
		});

		// changing the recurrence range
		$('#' + form_id + 'range_type').on('change', function onRangeTypeChange(e)
		{
			var range_type = $(this).val();

			$range_start_field.addClass('hidden');
			$range_end_field.addClass('hidden');
			$count_range_field.addClass('hidden');

			switch (range_type) {
				case 'date_range':
					$range_start_field.removeClass('hidden');
					$range_end_field.removeClass('hidden');
				break;
				case 'end_after_count':
					$range_start_field.removeClass('hidden');
					$count_range_field.removeClass('hidden');
				break;
				case 'no_end_date':
					$range_start_field.removeClass('hidden');
				break;
				default:
					// doing nothing for now
			}
		});

		// change of radios on the daily pattern
		$('.daily-radios').on('change', function onDailyRadioChange(e)
		{
			var every_weekday = $(this).val();
			var disable_days  = false;

			if (every_weekday === '1') { // every weekday checked
				disable_days = true;
			}

			$('#' + form_id + 'daily_every_days').prop('disabled', disable_days);
		});

		// change of radios on the monthly pattern
		$('.monthly-radios').on('change', function onMonthlyRadioChange(e)
		{
			var monthly_every         = $(this).val();
			var monthly_days_disabled = false;

			if (monthly_every === '1') { // the first Friday of every...checked
				monthly_days_disabled = true;
			}

			$('#' + form_id + 'monthly_day').prop('disabled', monthly_days_disabled);
			$('#' + form_id + 'monthly_every_months-0').prop('disabled', monthly_days_disabled);

			$('#' + form_id + 'monthly_ordinal').prop('disabled', !monthly_days_disabled);
			$('#' + form_id + 'monthly_ordinal_day').prop('disabled', !monthly_days_disabled);
			$('#' + form_id + 'monthly_every_months-1').prop('disabled', !monthly_days_disabled);
		});

		// change of radios on the yearly pattern
		$('.yearly-radios').on('change', function onYearlyRadioChange(e)
		{
			var yearly_on            = $(this).val();
			var yearly_days_disabled = false;

			if (yearly_on === '1') { // on the first Friday of...checked
				yearly_days_disabled = true;
			}

			$('#' + form_id + 'yearly_month-0').prop('disabled', yearly_days_disabled);
			$('#' + form_id + 'yearly_month_day').prop('disabled', yearly_days_disabled);

			$('#' + form_id + 'yearly_ordinal').prop('disabled', !yearly_days_disabled);
			$('#' + form_id + 'yearly_ordinal_day').prop('disabled', !yearly_days_disabled);
			$('#' + form_id + 'yearly_month-1').prop('disabled', !yearly_days_disabled);
		});

		// trigger dropdowns on page load
		$('#' + form_id + 'pattern').trigger('change');
		$('#' + form_id + 'range_type').trigger('change');
	}

	function _checkForType()
	{
		let type     = $('#' + form_id + 'type').val();
		let template = $('#taskaddedit-template_id').val();

		if (type === 'email' && template) {
			$('.send-creator-btn').removeClass('hidden');
			$('.template-groups').removeClass('hidden');
		} else {
			$('.template-groups').addClass('hidden');
		}
	}
}(jQuery, window.Adzuki || {}));
